export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13811.3466c597.jpg";